import { useState } from "react";
import { Form, Button, Modal } from "antd"
import { EditOutlined } from "@ant-design/icons"
import CurrencyForm from "./form/CurrencyForm";
import { currencyUpdateAsync } from "../../../app/store/reducers/currency/currencyReducer";



const UpdateCurrencyModal = ({currency}) => {
    const [form] = Form.useForm()  
    const [show, setShow] = useState(false);
    const showModal = () => {
      if (currency) {
        form.setFieldValue("name", currency?.name)
        form.setFieldValue("amount", currency?.amount)
      }
      setShow(true);
    };
    const handleCancel = () => {
      setShow(false);
    };
  
    const onSubmit = async (values) => {
      console.log("values", values);
      await currencyUpdateAsync({id: currency?.id, amount: values?.amount})
        .then(() => {
          handleCancel()
        })
        .catch(() => {
          
        })
    }
  
    const handleOk = () => {
      form
        .validateFields()
        .then((values) => {
          onSubmit(values)
          form.resetFields();
        })
        .catch((info) => {
          console.log("Validate Failed:", info);
        });
    };
  
  
    return (
      <>
        <Button style={{color: "orange", fontSize: "20px"}} className="d-flex align-items-center justify-content-center" onClick={showModal}>
            <EditOutlined />
        </Button>
        <Modal 
          title="Register Category" 
          open={show} 
          okText="Update"
          cancelText="Cancel"
          onOk={handleOk} 
          onCancel={handleCancel}
          >
            <Form
              form={form}
              layout="vertical"
              onFinish={onSubmit}
          >
            <CurrencyForm/>
            </Form>
        </Modal>
      </>
    );
}

export default UpdateCurrencyModal